import { Link, useParams } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

const bannerImg =
  "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20banner%20of%20misty%20mountain%20peaks%20and%20clouds%20in%20warm%20cream%20and%20golden%20tones%2C%20hand%20drawn%20brush%20strokes%2C%20serene%20traditional%20xianxia%20cultivation%20atmosphere%2C%20soft%20dreamy%20light%2C%20minimal%20elegant&width=1600&height=480&seq=section-banner-sxs&orientation=landscape";

export default function SectionList() {
  const { slug = "" } = useParams();
  const category = categories.find((c) => c.slug === slug);
  const list = category ? articles.filter((a) => a.category === slug) : articles;

  const title = category ? `${category.name} · 师兄啊师兄剧情讨论区` : "全部剧情讨论 · 师兄啊师兄讨论区";
  const description = category
    ? `${category.desc} 师兄啊师兄${category.name}深度解析，剧情脉络、伏笔与角色成长全梳理，同好陪你一起追更讨论。`
    : "师兄啊师兄全部剧情讨论与解析，宗门篇剧情、修炼境界体系、主线走向与伏笔盘点一网打尽。";

  return (
    <>
      <Seo title={title} description={description} path={`/section/${slug}`} />

      <section className="relative w-full overflow-hidden">
        <div className="h-44 w-full md:h-56">
          <img src={bannerImg} alt="师兄啊师兄剧情讨论区水墨横幅" className="h-full w-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-foreground-950/40"></div>
        <div className="absolute inset-0 flex w-full items-center px-4 md:px-6">
          <div className="container-x">
            <nav className="flex items-center gap-1.5 text-xs text-background-200/80" aria-label="面包屑">
              <Link to="/" className="hover:text-background-50">
                首页
              </Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-background-50">{category ? category.name : "全部讨论"}</span>
            </nav>
            <h1 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              {category ? category.name : "全部剧情讨论"}
            </h1>
            <p className="mt-2 max-w-2xl text-sm text-background-200/90">{category ? category.desc : "全部栏目的一网打尽"}</p>
          </div>
        </div>
      </section>

      <div className="container-x grid grid-cols-1 gap-8 py-10 lg:grid-cols-4 md:py-12">
        <div className="lg:col-span-3">
          <div className="flex items-center justify-between gap-3">
            <h2 className="font-heading text-lg font-semibold text-foreground-950">
              共 {list.length} 篇相关讨论
            </h2>
            <span className="text-sm text-foreground-400">按更新时间排序</span>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2">
            {list.map((a) => (
              <ArticleCard key={a.id} article={a} />
            ))}
          </div>
        </div>

        <aside className="lg:col-span-1" aria-label="栏目导航">
          <div className="sticky top-24 rounded-xl border border-background-200/70 bg-background-100/60 p-5">
            <h3 className="font-heading text-sm font-semibold text-foreground-950">栏目导航</h3>
            <nav className="mt-3 space-y-1">
              <Link
                to="/section/all"
                className={`flex items-center justify-between rounded-lg px-3 py-2.5 text-sm transition-colors ${
                  !category ? "bg-primary-50 font-medium text-primary-700" : "text-foreground-600 hover:bg-background-50"
                }`}
              >
                全部讨论
                <span className="text-xs text-foreground-400">{articles.length}</span>
              </Link>
              {categories.map((c) => {
                const count = articles.filter((a) => a.category === c.slug).length;
                const active = category?.slug === c.slug;
                return (
                  <Link
                    key={c.slug}
                    to={`/section/${c.slug}`}
                    className={`flex items-center justify-between rounded-lg px-3 py-2.5 text-sm transition-colors ${
                      active ? "bg-primary-50 font-medium text-primary-700" : "text-foreground-600 hover:bg-background-50"
                    }`}
                  >
                    <span className="flex items-center gap-2">
                      <i className={`${c.icon} ${active ? c.accent : "text-foreground-400"}`}></i>
                      {c.name}
                    </span>
                    <span className="text-xs text-foreground-400">{count}</span>
                  </Link>
                );
              })}
            </nav>

            <h3 className="mt-6 border-t border-background-200/70 pt-4 font-heading text-sm font-semibold text-foreground-950">
              热点标签
            </h3>
            <div className="mt-3 flex flex-wrap gap-2">
              {["宗门篇", "修炼境界", "主线剧情", "伏笔盘点", "角色志", "金丹", "名场面", "追更"].map((t) => (
                <Link
                  key={t}
                  to="/section/zongmen"
                  className="rounded-full border border-background-200 bg-background-50 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  #{t}
                </Link>
              ))}
            </div>

            <Link
              to="/contact"
              className="mt-6 flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-chat-3-line"></i>
              想聊，就来留言
            </Link>
          </div>
        </aside>
      </div>
    </>
  );
}